import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-53">
      {/* Background Glows */}
      <div className="absolute top-20 left-1/4 w-96 h-96 bg-emerald-500/15 blur-[120px] rounded-full pointer-events-none" data-id="element-54" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-emerald-600/15 blur-[150px] rounded-full pointer-events-none" data-id="element-55" />

      {/* Decorative Elements */}
      <span className="absolute top-[15%] right-[8%] text-5xl opacity-[0.07] pointer-events-none select-none" data-id="element-56">
        🥑
      </span>
      <span className="absolute bottom-[20%] left-[5%] text-4xl opacity-[0.06] pointer-events-none select-none" data-id="element-57">
        🍊
      </span>
      <span className="absolute top-[60%] right-[3%] text-4xl opacity-[0.06] pointer-events-none select-none" data-id="element-58">
        🌙
      </span>
      <span className="absolute top-[5%] left-[10%] text-5xl opacity-[0.07] pointer-events-none select-none" data-id="element-59">
        ☀️
      </span>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-60">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-61">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left" data-id="element-62">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-6" data-id="element-63">
              Tu energía no se ha ido por la edad,{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-teal-500 text-glow" data-id="element-64">
                simplemente tus células han olvidado cómo fabricarla.
              </span>
            </h1>
            <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-65">
              El Protocolo de Estabilidad Biológica para recuperar tu vitalidad
              celular, eliminar la niebla mental y despertar con vigor después
              de los 40.
            </p>
            <div className="flex justify-center lg:justify-start" data-id="element-66">
              <CTAButton data-id="element-67" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative mx-auto w-full max-w-lg lg:max-w-full" data-id="element-68">
            {/* Image Glow */}
            <div className="absolute inset-0 bg-emerald-500/20 blur-[80px] rounded-full transform scale-90" data-id="element-69" />
            <img src="https://cdn.magicpatterns.com/uploads/5SjWp1hHGpNT2piKFrmnVX/heylloyd-image-b.png" alt="Metabolismo en Punto de Equilibrio (40+) en múltiples dispositivos" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-70" />
          </motion.div>
        </div>
      </div>
    </section>;
}